import React from 'react'
import MaterialSymbol from '../material-symbol'

const Stars = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="stars" {...props} />
))

Stars.displayName = 'Stars'

export default Stars
